import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { store } from './store';
import { queryClient } from './api/queryClient';
import { setAuth } from './store/slices/authSlice';
import { setCompany } from './store/slices/companySlice';
import { MOCK_MODE } from './mock/index';
import { mockAuthUser, mockCompany, mockPermissions } from './mock/company.mock';
import App from './App';
import './styles/globals.css';

if (MOCK_MODE) {
  store.dispatch(setAuth({
    user: mockAuthUser,
    companyId: mockCompany.id,
    accessToken: 'mock-token',
    permissions: mockPermissions,
  }));
  store.dispatch(setCompany(mockCompany));

  const savedTheme = localStorage.getItem('theme') || 'light';
  document.documentElement.classList.toggle('dark', savedTheme === 'dark');
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </StrictMode>
);
